import * as React from 'react'
// components
import PlanEditContainer from 'containers/Plan/Edit'

const PlanEditPage: React.FC = () => <PlanEditContainer />

export default PlanEditPage
